import cx from 'clsx';
import {
  fieldSubscription,
  getVisibleFieldError,
  parseDecimalClipboard,
  parseDecimalDraft,
  useField,
} from '@ff-it/form';
import { Box } from '@ff-it/ui';
import { amountInput } from './style.css';
const preserveValue = (value: string | null): string | null => value;
const formatValue = (value: string | number | null | undefined): string => (value == null ? '' : value.toString());

// this is here just because DecimalField is bound to FormGroup
export function AmountInput({ name }: { name: string }): React.ReactElement {
  const { input, meta } = useField<string | null, HTMLElement, string>(name, {
    parse: preserveValue,
    format: formatValue,
    subscription: fieldSubscription,
    allowNull: true,
    // validate: positive, depends on the source sign
  });

  const error = getVisibleFieldError(meta);

  return (
    <Box
      as="input"
      className={cx(amountInput, error && 'is-invalid')}
      type="text"
      {...input}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        const result = parseDecimalDraft(event.target.value, 2);
        if (result.accepted) input.onChange(result.value);
      }}
      onPaste={(event: React.ClipboardEvent<HTMLInputElement>) => {
        event.preventDefault();
        const result = parseDecimalClipboard(event.clipboardData.getData('text'), 2);
        if (result.accepted) input.onChange(result.value);
      }}
      autoComplete="off"
    />
  );
}
